var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\"><div flex=\"flex\"><div layout=\"column\" class=\"itemCardHeader\"><h4>Table Maps</h4></div><div style=\"margin: 5px\" class=\"form-group\"><label>Table Maps List Here.</label></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/venues/tabs/tab-table-maps.jade
// module id = 286
// module chunks = 0